export default __webpack_public_path__ + "static/media/dashboard.484c160e.png";